import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OpenApp } from '../models/open-app/open-app.model';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class OmOpenAppService extends RequestService<OpenApp> {
  static PATH = '/om/open/app';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, OmOpenAppService.PATH, globalService.debugUrl);
  }

  init() {
    return this.httpClient.get<OpenApp>(
      `${
        this.globalService.debugUrl
          ? this.globalService.debugUrl
          : environment.host
      }${OmOpenAppService.PATH}/init`
    );
  }
}
